import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../orders/services/order.service';
import { UserService } from '../common/services/user.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-email-unsubscribe',
    templateUrl: './email-unsubscribe.component.html',
    styleUrls: ['./email-unsubscribe.component.css'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class EmailUnsubscribeComponent implements OnInit {
  constructor
    (private titleService: Title,
    private route: ActivatedRoute,
    private userService: UserService) {
    titleService.setTitle('SGC Grading Unsubscribe From Marketing');
  }
  groupName: string = environment.sgc.unSubscribeGroupName;
  email!: string;
  maskedEmail!: string;
  encryptedEmail!: any;
  isSaving = false;
  titleHeading: string = 'SGC Grading Unsubscribe From Marketing';
  titleColor: string = '#2E3645';

  private key: string = 'oa9v6B6C50OLYhTWKIkaCQ==';
  isMarketingOptOut: boolean = false;  

  setToggle(value: boolean) {
    this.isMarketingOptOut = value;
    this.savePreferences();
  }


  // Save preferences method
  savePreferences() {
    const toggleValue = this.isMarketingOptOut;

    const requestBody = {
      encryptedText: this.encryptedEmail,  // assuming this is the encrypted email
      isUnsubscribe: this.isMarketingOptOut
    };
    this.userService.userEmailUnsubscribe(requestBody).subscribe(order => {
      this.isSaving = false;
      this.titleHeading = 'SGC Grading Unsubscribe From Marketing';
      this.titleColor = '#41896c';
    });
  }
  ngOnInit() {  
    this.route.queryParams.subscribe(params => {
      const encryptedEmail = params['email'];
      if (encryptedEmail) {
        this.encryptedEmail = encryptedEmail
        this.email = this.decryptEmail(encryptedEmail);
        this.maskedEmail = this.maskEmail(this.email);
      }
    });
    if (!this.email) return;
  }
  getEmail() {
    if (!this.route.snapshot.params) return null;

    return this.route.snapshot.params['email'];
  }
  decryptEmail(encryptedEmail: string): string {
    const key = CryptoJS.enc.Base64.parse(this.key); // Use Base64 parsing for the key
    const iv = CryptoJS.enc.Utf8.parse('\0'.repeat(16)); // Create zero IV (16 bytes of zeros)

    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedEmail), key, {
      iv: iv, // Explicitly set the IV here
      mode: CryptoJS.mode.CBC, // Ensure CBC mode is used
      padding: CryptoJS.pad.Pkcs7 // Ensure PKCS7 padding is used (default in AES)
    });

    return bytes.toString(CryptoJS.enc.Utf8);
  }
  maskEmail(email: string): string {
    const [localPart, domain] = email.split('@');
    const maskedLocalPart = localPart[0] + '*'.repeat(localPart.length - 2) + localPart[localPart.length - 1];
    const [domainName, domainExtension] = domain.split('.');
    const maskedDomain = domainName[0] + '*'.repeat(domainName.length - 2) + domainName[domainName.length - 1];
    return `${maskedLocalPart}@${maskedDomain}.${domainExtension}`;
  }
}
